import { FC, ReactNode, useLayoutEffect, useRef, useState } from 'react';

import { DetailedBasicInputProps } from './BasicInput.types';
import {
  PostfixIconWrapper,
  PrefixIconWrapper,
  Root,
  StyledBasicInput,
} from './BasicInput.ui';

export type BasicInputProps = Omit<
  DetailedBasicInputProps,
  'style' | 'className'
> & {
  isInvalid?: boolean;
  prefixIcon?: ReactNode;
  postfixIcon?: ReactNode;
  inputClassName?: string;
  inputStyle?: DetailedBasicInputProps['style'];
  rootClassName?: string;
  rootStyle?: DetailedBasicInputProps['style'];
};

export const BasicInput: FC<BasicInputProps> = (props) => {
  const {
    prefixIcon,
    postfixIcon,
    inputClassName,
    inputStyle,
    ref,
    rootClassName,
    rootStyle,
    isInvalid = false,
    ...inputProps
  } = props;

  const [paddingLeft, setPaddingLeft] = useState<number | undefined>();
  const [paddingRight, setPaddingRight] = useState<number | undefined>();

  const prefixIconRef = useRef<HTMLDivElement>(null);
  const postfixIconRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (prefixIcon && prefixIconRef.current) {
      setPaddingLeft(prefixIconRef.current.clientWidth);
    } else {
      setPaddingLeft(undefined);
    }
  }, [prefixIcon]);

  useLayoutEffect(() => {
    if (postfixIcon && postfixIconRef.current) {
      setPaddingRight(postfixIconRef.current.clientWidth);
    } else {
      setPaddingRight(undefined);
    }
  }, [postfixIcon]);

  return (
    <Root className={rootClassName} style={rootStyle}>
      {prefixIcon ? (
        <PrefixIconWrapper ref={prefixIconRef}>{prefixIcon}</PrefixIconWrapper>
      ) : null}

      <StyledBasicInput
        {...inputProps}
        ref={ref}
        className={inputClassName}
        isInvalid={isInvalid}
        style={{
          ...inputStyle,
          paddingLeft,
          paddingRight,
        }}
      />

      {postfixIcon ? (
        <PostfixIconWrapper ref={postfixIconRef}>
          {postfixIcon}
        </PostfixIconWrapper>
      ) : null}
    </Root>
  );
};
